import { initFederation } from '@angular-architects/native-federation';

// deployUrl derivado de la URL real de main.js: en releases versionadas
// (/releases/<id>/main-*.js) hace que remoteEntry.json y los bundles
// federados se carguen desde la ruta inmutable de la release en vez de la
// raiz del documento, evitando 404 en sesiones abiertas durante un deploy.
//
// Solo se aplica cuando la URL es una release versionada (/releases/<id>/).
// En dev (Vite sirve main.js desde /@fs/...) NO se aplica: ahi Native
// Federation resuelve remoteEntry.json contra la raiz por defecto; usar el
// deployUrl de /@fs/ daria 404 al buscar remoteEntry.json.
const baseUrl = new URL('.', import.meta.url).href;
const deployUrl = baseUrl.includes('/releases/') ? baseUrl : undefined;

initFederation(undefined, deployUrl ? { deployUrl } : undefined)
  .catch((err: unknown) => console.error(err))
  .then(() => import('./bootstrap'))
  .catch((err: unknown) => console.error(err));
